import styled from 'styled-components';
import ImageWrapper from '../../../../new-components/ImageWrapper';
import { useContext } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../../search-new/context/SearchContext';
import { SearchFiltersTypes } from '../../../../reducers/search-filters/reducer';
import { SearchFiltersActionTypes } from '../../../../reducers/search-filters/actions';
import { useTranslation } from 'next-i18next';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { getNowDate } from '../../../../helpers/search-options/common';

interface SelectionFilterCardProps {
  icon?: any;
  id?: number;
  index?: number;
  name?: string;
  filterValue?: any;
  options?: any;
  filterType:
    | SearchFiltersTypes.PROPERTY_TYPES
    | SearchFiltersTypes.DELIVERY_DATE;
}

const SelectionFilterCard = ({
  icon,
  id,
  index,
  name,
  filterValue,
  options,
  filterType
}: SelectionFilterCardProps) => {
  const { t } = useTranslation('search');
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { locale } = useRouter();

  const { searchFiltersState, searchFiltersDispatch } = useContext(
    SearchContext
  ) as SearchContextInterface;

  const isDeliveryDateDisabled =
    (filterType === SearchFiltersTypes.DELIVERY_DATE &&
      searchFiltersState.searchFilters.nawy_now &&
      searchFiltersState.searchFilters.delivery_date === getNowDate()) ||
    false;

  const checked =
    (filterType === SearchFiltersTypes.PROPERTY_TYPES &&
      searchFiltersState.searchFilters[filterType].includes(id!)) ||
    (filterType === SearchFiltersTypes.DELIVERY_DATE &&
      searchFiltersState.searchFilters[filterType] === filterValue);

  const optionHandler = () => {
    if (filterType === SearchFiltersTypes.PROPERTY_TYPES) {
      let selectedValues =
        searchFiltersState.searchFilters[SearchFiltersTypes.PROPERTY_TYPES];

      if (selectedValues?.includes(id!)) {
        selectedValues = selectedValues!.filter(value => value != id);
      } else {
        selectedValues = [...selectedValues!, id!];
      }

      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
        payload: {
          name: SearchFiltersTypes.PROPERTY_TYPES,
          value: selectedValues
        }
      });
    }

    if (filterType === SearchFiltersTypes.DELIVERY_DATE) {
      let selectedValue =
        searchFiltersState.searchFilters[SearchFiltersTypes.DELIVERY_DATE];

      if (selectedValue === filterValue) {
        searchFiltersDispatch({
          type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
          payload: {
            name: filterType,
            value: undefined
          }
        });
      } else {
        searchFiltersDispatch({
          type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
          payload: {
            name: filterType,
            value: filterValue
          }
        });
      }
    }
  };

  return (
    <Container
      dir={locale === 'ar' ? 'rtl' : 'ltr'}
      className={isDeliveryDateDisabled ? 'dimmed' : ''}
    >
      <div className="info">
        {icon && isMobile && (
          <ImageWrapper
            src={icon}
            alt={`${name} icon`}
            width={27.5}
            height={25}
            objectFit="cover"
          />
        )}

        <span
          className="type"
          style={{ ...(isDeliveryDateDisabled && { color: '#818181' }) }}
        >
          {filterType === SearchFiltersTypes.PROPERTY_TYPES
            ? name
            : t(options?.displayedValue)}
        </span>
      </div>

      <CustomCheckbox
        disabled={isDeliveryDateDisabled}
        checked={checked}
        onChange={optionHandler}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: row-reverse;
  padding: 16px;
  gap: 8px;
  border-radius: 7.5px;
  background-color: #f9fafb;

  &.dimmed {
    pointer-events: none;
    background-color: #e0e0e0;
    color: #818181;
  }

  .info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .type {
    font-size: 14px;
    color: #000000;
    font-family: materialMedium;
  }

  .checkbox {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    border: 1px solid #d1d4d9;
    background-color: #fff;
  }

  @media screen and (max-width: ${props =>
      props.theme.breakPoints.mobile.max}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

const CustomCheckbox = styled.input.attrs({ type: 'checkbox' })`
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 1px solid #d1d4d9;
  background: #fff;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;

  &:checked {
    background-color: #fff;
    border-color: #d1d4d9;
  }

  &:checked::before {
    content: '✓';
    display: block;
    text-align: center;
    color: #015c9a;
  }
`;

export default SelectionFilterCard;
